import { defineStore } from 'pinia';
import { ref } from 'vue';

export enum InteractionView {
  INPUT,
  OPEN_REQUEST_DESCRIPTION,
  SUPPORT_REQUEST_DESCRIPTION,
  LIVE_CHAT_INDICATOR,
  /** Active Twilio agent voice call. */
  VOICE_CHAT_INDICATOR,
  END_CHAT_BUTTON,
  CSAT,
  LOGIN,
  GUEST_FORM,
  LANDING,
  /** Active landing Voice AI session (@pleased-npm/voice-ai-client). */
  LANDING_AI_VOICE_INDICATOR,
  NONE,
}

export const useChatWidget = defineStore('chatWidget', () => {
  const isChatOverlayVisible = ref(false);
  const interactionView = ref<InteractionView>(InteractionView.INPUT);
  /** Persists across ChatWidget unmount (e.g. float button / minimize) so overlay views can be restored. */
  const lastViewBeforeClose = ref<InteractionView | null>(null);

  function setIsChatOverlayVisible(visible: boolean) {
    isChatOverlayVisible.value = visible;
  }

  function setInteractionView(view: InteractionView) {
    interactionView.value = view;
  }

  // TODO: add here events for some of interaction views, which users can subscribe to
  // For example, open request description view should send description once user submits it
  // And Open Request composable should be able to subscribe to it and use it's data to determine next step

  return {
    interactionView,
    isChatOverlayVisible,
    lastViewBeforeClose,

    setInteractionView,
    setIsChatOverlayVisible,
  };
});
